// PRODUCT SINGLE:
// - urgency-ротатор + countdown,
// - sticky-bar,
// - галерея-переключение,
// - верх подписчика Infinity Pass.

// Buy Now живёт без JS: ВСЕ четыре CTA - обычные <a href="{{ buy_url }}">.
// 25.08: маркетинговые три (bb-cta, cv-stack-cta, sticky-bar-cta) были
// <button data-action="buy-now"> на делегаторе includes/buynow.js,
// который никто не импортировал - кнопки молча не кликались. Делегатор
// умел ровно location.href = dataset.href, то есть подменял ссылку,
// теряя среднюю кнопку мыши, «копировать адрес» и работу без JS.
// Модуль удалён. 07.09: свотчи вариаций приехали - и остались
// ЧИСТЫМИ ссылками /{slug}/s/{store}?v={id} без JS вообще. Причина:
// продавца под вариацию подбирает singleAction (у текущего может не
// быть оффера), то есть переход обязателен - перехват клика лишь
// рассинхронил бы цену с магазином в URL.

import { axios } from './plugins/http';

// Персональное состояние зоны покупки: сингл кэшируемый и обезличенный
// (auth в рендере не участвует), поэтому и владение, и Pass доезжают
// запросами после загрузки.
//
// Два запроса ПАРАЛЛЕЛЬНО - зона ждёт оба, а не по очереди. Приоритет
// при разборе: ВЛАДЕНИЕ ГЛАВНЕЕ PASS - товар уже в библиотеке, значит
// предлагать забрать его по подписке бессмысленно.
//
// Живой Pass (trial | active | canceled до конца периода) - Free-цена
// и кнопка клейма; триал с выбранным лимитом - стена с двумя выходами.

// Потолок ожидания ответов, мс: дальше возвращаем кнопку покупки
const LOADER_TIMEOUT = 5000;

// Секунды отсчёта в окне "нужна карта" до автоперехода в ЛК
const GATE_DELAY = 7;

document.addEventListener( 'DOMContentLoaded', function() {

    const ctaZone  = document.querySelector('.cta-zone');
    const claimBtn = document.getElementById('passClaimBtn');

    if( ! ctaZone || ! claimBtn )
        return;

    const payload = {
        slug         : ctaZone.dataset.slug || '',
        variation_id : parseInt( ctaZone.dataset.variation, 10 ) || 0,
    };

    // Зону покупки на время ожидания прячем целиком: состояний у неё
    // четыре, и Pass-стена приносит ВТОРУЮ кнопку - подменять текст
    // внутри Buy Now всё равно дёрнуло бы вёрстку на ответе. Цена,
    // перки и пикер уезжают вместе с кнопками, иначе на глаз поедет
    // порядок блоков: скелетон стоит ПЕРЕД ценой.
    //
    // Скелетон ставит только JS: при отключённом или упавшем скрипте
    // страница остаётся такой, какой её отдал сервер
    const skeleton = document.getElementById('ctaSkeleton');

    const hidden = [
        document.getElementById('priceBlock'),
        // только прямой сосед: такой же .whats-included лежит ВНУТРИ
        // скелетона, обычный querySelector взял бы его
        skeleton ? skeleton.parentNode.querySelector(':scope > .whats-included') : null,
        document.getElementById('variationPicker'),
        ctaZone,
    ];

    showLoader();

    // Предохранитель: ответ может не прийти вовсе (сеть, 502 у обоих).
    // Вечный спиннер вместо кнопки покупки - хуже любого состояния,
    // поэтому по таймауту возвращаем исходный вид
    let settled = false;

    const failsafe = setTimeout( function() {

        if( ! settled )
            hideLoader();

    }, LOADER_TIMEOUT );

    // allSettled: отказ одного контура не должен ронять другой
    Promise.allSettled([
        axios.post( '/checkout/owned', payload ),
        axios.post( '/subscribe/pass', {} ),
    ]).finally( function() {

        settled = true;

        clearTimeout( failsafe );

        hideLoader();

    } ).then( function( results ) {

        const owned = results[0].status === 'fulfilled'
            ? dataOf( results[0].value )
            : null;

        const pass = results[1].status === 'fulfilled'
            ? dataOf( results[1].value )
            : null;

        // купленные вариации гасим всегда - даже если выбрана не купленная
        if( owned && Array.isArray( owned.variations ) )
            dimOwnedSwatches( owned.variations );

        // владение выбранной вариацией закрывает вопрос: Pass не применяем
        if( owned && owned.owned ) {
            activateOwnedView();
            return;
        }

        const sub = pass && pass.sub ? pass.sub : null;

        // Живого Pass нет (или запрос не удался) - показываем апселл.
        // В разметке он скрыт: HTML-версия страницы предлагает только
        // покупку, подписку добавляет JS
        if( ! sub || ['trial', 'active', 'canceled'].indexOf( sub.state ) === -1 ) {

            const upsell = document.getElementById('passUpsell');

            if( upsell )
                upsell.hidden = false;

            return;
        }

        activatePassView( sub );
    } );

    // Скелетон вместо живых блоков. Разметки нет (старый кэш шаблона) -
    // ничего не прячем: пустая зона хуже, чем блоки на секунду раньше
    function showLoader() {

        if( ! skeleton )
            return;

        hidden.forEach( function( el ) { if( el ) el.hidden = true; } );

        skeleton.hidden = false;
    }

    function hideLoader() {

        if( ! skeleton )
            return;

        skeleton.hidden = true;

        hidden.forEach( function( el ) { if( el ) el.hidden = false; } );
    }

    // конверт ajax-тракта: полезная нагрузка в data.data
    function dataOf( response ) {

        return response && response.data ? response.data.data : null;
    }

    // Уже в библиотеке: продажную зону снимаем целиком (цена, таймер,
    // Buy Now, апселл Pass) и показываем кнопку-заглушку
    function activateOwnedView() {

        // priceBlock целиком: внутри и цена, и таймер распродажи -
        // купленному не нужно ни то, ни другое
        ['priceBlock', 'buyNowBtn', 'passUpsell'].forEach( function( id ) {

            const el = document.getElementById( id );
            if( el )
                el.hidden = true;
        } );

        const ownedBtn = document.getElementById('ownedBtn');
        if( ownedBtn )
            ownedBtn.hidden = false;
    }

    // Купленные вариации: гасим и глушим клик - покупать повторно
    // нечего, а остальные свотчи остаются рабочими ссылками
    function dimOwnedSwatches( variations ) {

        document.querySelectorAll('.variation-item[data-variation]').forEach( function( item ) {

            if( variations.indexOf( parseInt( item.dataset.variation, 10 ) ) === -1 )
                return;

            item.classList.add('variation-item--owned');
            item.setAttribute( 'aria-disabled', 'true' );
            item.title = 'Already in your library';

            const price = item.querySelector('.variation-item-price');
            if( price )
                price.textContent = 'In library';

            item.addEventListener( 'click', function( e ) {
                e.preventDefault();
            } );
        } );
    }

    // Стена лимита: даты и счётчик приезжают из панели, цена товара
    // отрендерена сервером. Цена Pass в мелком тексте - только если
    // бэк её прислал (passPrice, центы), иначе фразу не показываем
    function showPassWall( sub ) {

        const wall = document.getElementById('passWall');

        if( ! wall )
            return;

        const total  = document.getElementById('pwTotal');
        const refill = document.getElementById('pwRefill');
        const wait   = document.getElementById('pwWait');
        const wrap   = document.getElementById('pwWaitWrap');

        if( total )
            total.textContent = sub.trialDlTotal;

        // Отменённому обещать пополнение нельзя - у него Pass кончается
        if( sub.state === 'canceled' ) {

            const refillWrap = document.getElementById('pwSubRefill');
            const endsWrap   = document.getElementById('pwSubEnds');
            const ends       = document.getElementById('pwEnds');

            if( ends )
                ends.textContent = sub.renewDate || sub.trialEnd || 'soon';

            if( refillWrap )
                refillWrap.hidden = true;

            if( endsWrap )
                endsWrap.hidden = false;

        } else if( refill && sub.renewDate ) {
            refill.textContent = sub.renewDate;
        }

        const days = parseInt( sub.trialLeft, 10 ) || 0;

        if( wait && wrap && days > 0 ) {
            wait.textContent = days + ( days === 1 ? ' day' : ' days' );
            wrap.hidden      = false;
        }

        const price = parseInt( sub.passPrice, 10 ) || 0;
        const fine  = document.getElementById('pwFine');
        const priceEl = document.getElementById('pwPassPrice');

        if( fine && priceEl && price > 0 ) {
            priceEl.textContent = '$' + ( price / 100 ).toFixed( 2 );
            fine.hidden         = false;
        }

        wall.hidden = false;

        bindUnlock();
    }

    // Окно "нужна карта" (#pwCardGate): формы карты на карточке товара НЕТ
    // (решение 18.09), поэтому на 409 не пишем мелкий текст в никуда, а
    // показываем окно и сами уводим в ЛК через GATE_DELAY. Кнопка "Go now" -
    // обычная ссылка, редирект делает браузер.
    //
    // "Stay on this page" и клик по фону отменяют отсчёт, но текст ошибки
    // тогда перекладываем в #pwFine - человек не должен остаться без
    // объяснения, почему Pass не стартовал
    var gateTimer = null;

    function closeCardGate( message ) {

        const gate = document.getElementById('pwCardGate');

        clearInterval( gateTimer );
        gateTimer = null;

        if( gate )
            gate.classList.remove('open');

        const fine = document.getElementById('pwFine');

        if( fine && message ) {
            fine.textContent = message;
            fine.hidden      = false;
        }
    }

    function openCardGate( message ) {

        const gate  = document.getElementById('pwCardGate');
        const text  = document.getElementById('pwGateText');
        const timer = document.getElementById('pwGateTimer');

        // разметки нет (старый кэш шаблона) - показываем хотя бы текст
        if( ! gate ) {

            const fine = document.getElementById('pwFine');

            if( fine ) {
                fine.textContent = message;
                fine.hidden      = false;
            }

            return;
        }

        // второй клик по кнопке не должен заводить второй отсчёт
        if( gateTimer )
            return;

        if( text )
            text.textContent = message;

        let left = GATE_DELAY;

        if( timer )
            timer.textContent = left;

        gate.classList.add('open');

        gateTimer = setInterval( function() {

            left--;

            if( timer )
                timer.textContent = left > 0 ? left : 0;

            if( left > 0 )
                return;

            clearInterval( gateTimer );
            gateTimer = null;

            window.location.href = ( window.baseURL || '' ) + '/account';

        }, 1000 );

        const stay = document.getElementById('pwGateStay');

        if( stay && ! stay.dataset.bound ) {
            stay.dataset.bound = '1';
            stay.addEventListener( 'click', function() { closeCardGate( message ); } );
        }

        if( ! gate.dataset.bound ) {
            gate.dataset.bound = '1';
            gate.addEventListener( 'click', function( e ) {
                if( e.target === gate ) closeCardGate( message );
            } );
        }
    }

    // "Unlock now": досрочно закрываем триал (POST /subscribe/upgrade -
    // Stripe списывает карту, лимит уходит). Успех - перезагружаем
    // страницу: зона покупки пересоберётся уже с активным Pass.
    //
    // Карты нет - бэк отвечает 409 с подсказкой: её показываем в окне
    // #pwCardGate, которое уводит в ЛК
    function bindUnlock() {

        const btn = document.getElementById('pwUnlock');

        if( ! btn || btn.dataset.bound )
            return;

        btn.dataset.bound = '1';

        const label = btn.textContent;

        btn.addEventListener( 'click', function() {

            if( btn.dataset.busy )
                return;

            btn.dataset.busy = '1';
            btn.textContent  = 'Starting your Pass…';

            axios.post( '/subscribe/upgrade', {} )
                .then( function() {
                    window.location.reload();
                } )
                .catch( function( err ) {

                    const status = err && err.response ? err.response.status : 0;
                    const data   = err && err.response ? err.response.data : null;

                    // Текст бэка честный: нет карты - 409 с подсказкой.
                    // Своей формы на карточке товара нет (решение 18.09),
                    // карту добавляют в ЛК
                    const message = data && data.data && data.data.message
                        ? data.data.message
                        : 'Could not start your Pass. Please try again.';

                    delete btn.dataset.busy;
                    btn.textContent = label;

                    const code = status || ( data && data.code ) || 0;

                    // 409 = нужна карта: одним мелким текстом человека не
                    // увести, поднимаем окно с отсчётом до ЛК
                    if( code === 409 ) {
                        openCardGate( message );
                        return;
                    }

                    const fine = document.getElementById('pwFine');

                    if( ! fine )
                        return;

                    fine.textContent = message;
                    fine.hidden      = false;
                } );
        } );
    }

    function activatePassView( sub ) {

        ['basePriceRow', 'buyNowBtn', 'passUpsell'].forEach( function( id ) {

            const el = document.getElementById( id );
            if( el )
                el.hidden = true;
        } );

        // продажный таймер подписчику ни к чему
        const countdown = document.querySelector('.cv-countdown');
        if( countdown )
            countdown.hidden = true;

        ['passStrip', 'passPriceRow', 'passAccessNote'].forEach( function( id ) {

            const el = document.getElementById( id );
            if( el )
                el.hidden = false;
        } );

        claimBtn.hidden = false;

        const label = document.getElementById('passClaimText');

        // Лимит триала выбран - забор закрыт (бэк гардит то же самое).
        // Вместо погашенной кнопки показываем стену с двумя выходами:
        // апгрейд Pass и разовая покупка по обычному чекауту.
        //
        // Отменённый триал (state canceled, prevState trial) - тот же
        // лимит: доступ жив до конца периода, но забранные товары уже
        // выбраны, и на account гвард считает их так же (status trialing)
        const onTrial = sub.state === 'trial'
            || ( sub.state === 'canceled' && sub.prevState === 'trial' );

        if( onTrial && sub.trialDlUsed >= sub.trialDlTotal ) {

            claimBtn.hidden = true;

            // Забирать бесплатно больше нельзя - откатываем Pass-вид зоны
            // цены: юзер платит, значит видит цену, а не Free. Обещания
            // "включено в Pass" тоже снимаем
            ['passPriceRow', 'passStrip', 'passAccessNote'].forEach( function( id ) {

                const el = document.getElementById( id );
                if( el )
                    el.hidden = true;
            } );

            const base = document.getElementById('basePriceRow');
            if( base )
                base.hidden = false;

            showPassWall( sub );

            return;
        }

        claimBtn.addEventListener( 'click', function( e ) {

            e.preventDefault();

            if( claimBtn.classList.contains('disabled') || claimBtn.dataset.busy )
                return;

            claimBtn.dataset.busy = '1';
            label.textContent = 'Adding to your library…';

            axios.post( '/checkout/claim', {
                slug         : claimBtn.dataset.slug,
                variation_id : parseInt( claimBtn.dataset.variation, 10 ) || 0,
            } )
                .then( function( response ) {

                    const data = response && response.data ? response.data.data : null;
                    if( ! data || ! data.redirect )
                        throw new Error('No redirect');

                    window.location.href = data.redirect;
                } )
                .catch( function( err ) {

                    delete claimBtn.dataset.busy;

                    const message = err && err.response && err.response.data && err.response.data.data
                        ? err.response.data.data.message : '';

                    label.textContent = message || 'Something went wrong — try again';
                } );
        } );
    }
} );

document.addEventListener('DOMContentLoaded', function () {

    // urgency-ротатор: фразы по кругу
    const msgs = document.querySelectorAll('#urgencyRotator .urgency-msg');
    if (msgs.length > 1) {
        let mi = 0;
        setInterval(function () {
            msgs[mi].classList.remove('active');
            mi = (mi + 1) % msgs.length;
            msgs[mi].classList.add('active');
        }, 4000);
    }

    // countdown до полуночи (ЗАГЛУШКА: честный дедлайн придёт с акциями)
    const H = document.getElementById('cvH'),
        M = document.getElementById('cvM'),
        S = document.getElementById('cvS');
    if( H ) setInterval(function () {
        let now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
        let d = Math.max(0, (end - now) / 1000 | 0);
        H.textContent = String(d / 3600 | 0).padStart(2, '0');
        M.textContent = String((d % 3600) / 60 | 0).padStart(2, '0');
        S.textContent = String(d % 60).padStart(2, '0');
    }, 1000);

    // sticky-bar: показать, когда buy-зона ушла за верх экрана
    const bar = document.getElementById('stickyBar');
    const info = document.querySelector('.product-info');
    if (bar && info) {
        let tick = false;
        window.addEventListener('scroll', function () {
            if (tick) return;
            tick = true;
            requestAnimationFrame(function () {
                bar.classList.toggle('vis', info.getBoundingClientRect().bottom < 0);
                tick = false;
            });
        }, { passive: true });
    }

    // галерея-СЛАЙДЕР (29.07, дописан до стилей макета): flex-трек
    // двигается transform'ом, стрелки .show на 2+ слайдах, индикаторы
    // генерятся по числу слайдов. Старый active-toggle умер - стили
    // макета его никогда не понимали
    const track = document.getElementById('gallerySlides');
    if (track && track.children.length > 0) {
        const slides = track.children;
        let n = slides.length;
        let gi = 0;

        const indicatorsWrap = document.getElementById('galleryIndicators');
        let indicators = [];

        function goTo(i) {
            // уходим со слайда - видео на нём ставим на паузу
            const playing = slides[gi].querySelector('video');
            if (playing) playing.pause();

            gi = (i + n) % n;
            track.style.transform = 'translateX(-' + (gi * 100) + '%)';

            indicators.forEach(function (ind, k) {
                ind.classList.toggle('active', k === gi);
            });
        }

        if (n > 1) {
            // индикаторы-полосочки
            if (indicatorsWrap) {
                for (let k = 0; k < n; k++) {
                    let b = document.createElement('button');
                    b.type = 'button';
                    b.className = 'gallery-indicator' + (k === 0 ? ' active' : '');
                    b.setAttribute('aria-label', 'Slide ' + (k + 1));
                    (function (kk) {
                        b.addEventListener('click', function () { goTo(kk); });
                    })(k);
                    indicatorsWrap.appendChild(b);
                    indicators.push(b);
                }
            }

            // стрелки: включаем и вешаем листание
            document.querySelectorAll('.gallery-arrow').forEach(function (btn) {
                btn.classList.add('show');
                btn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    goTo(gi + (btn.dataset.action === 'gallery-prev' ? -1 : 1));
                });
            });

            // клик по картинке - следующий слайд (видео-слайд играет, не листает)
            track.addEventListener('click', function (e) {
                if (e.target.closest('.gallery-video')) return;
                goTo(gi + 1);
            });
        }

        // видео-слайд: постер -> inline <video>
        track.querySelectorAll('.gallery-video').forEach(function (slide) {
            slide.addEventListener('click', function (e) {
                e.stopPropagation();
                if (slide.querySelector('video')) return;
                let v = document.createElement('video');
                v.src = slide.dataset.video;
                v.controls = true;
                v.autoplay = true;
                v.playsInline = true;
                slide.innerHTML = '';
                slide.appendChild(v);
            });
        });
    }
});

// табы Description/Reviews/Shipping
document.addEventListener('DOMContentLoaded', function () {
    const btns = document.querySelectorAll('.tabs-nav .tab-btn');
    btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            btns.forEach(function (b) { b.classList.remove('active'); });
            document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
            btn.classList.add('active');
            const panel = document.getElementById('tab-' + btn.dataset.tab);
            if (panel)
                panel.classList.add('active');
        });
    });

    // аккордеоны правой колонки
    document.querySelectorAll('.info-acc-header').forEach(function (h) {
        h.addEventListener('click', function () {
            h.closest('.info-acc').classList.toggle('open');
        });
    });
});

// FAQ "Before you buy" - аккордеон
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cv-faq-q').forEach(function (q) {
        q.addEventListener('click', function () {
            q.closest('.cv-faq-item').classList.toggle('open');
        });
    });
});

// Отзывы: Vue (reviews.js + ReviewsApp.vue), здесь только открывашка таба по ссылке "N reviews" в шапке
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-action="goto-reviews"]').forEach(function (a) {
        a.addEventListener('click', function (e) {

            e.preventDefault();

            const btn = document.querySelector('.tab-btn[data-tab="reviews"]');
            if (btn)
                btn.click();

            document.querySelector('.tabs-nav').scrollIntoView({ behavior: 'smooth' });
        });
    });
});

// spotlight-карусель: стрелки скроллят трек на ширину карточки
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.spotlight-azrow').forEach(function (wrap) {
        const track = wrap.querySelector('.spotlight-row, .spotlight-duo');
        if( ! track )
            return;

        wrap.querySelectorAll('.spotlight-slider-arrow').forEach(function (btn) {
            btn.addEventListener('click', function () {
                const card = track.firstElementChild;
                const step = card ? card.offsetWidth + 16 : 300;
                track.scrollBy({ left: btn.classList.contains('l') ? -step : step, behavior: 'smooth' });
            });
        });
    });
});